const IST = "Asia/Kolkata";

export const formatDate = (d) =>
    d
        ? new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric", timeZone: IST })
        : "-";

export const formatDateTime = (d) =>
    d
        ? new Date(d).toLocaleString("en-IN", {
            day: "2-digit", month: "short", year: "numeric",
            hour: "2-digit", minute: "2-digit", hour12: true, timeZone: IST,
        })
        : "-";

// departure_time (UTC ISO) -> "08:00 AM" in IST
export const formatSlotTime = (d) =>
    d
        ? new Date(d).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: true, timeZone: IST })
        : "-";

// slot "18:00" (IST) -> "06:00 PM"
export const formatSlotLabel = (slot) => {
    if (!slot) return "-";
    const [h, m] = slot.split(":").map(Number);
    return new Date(1970, 0, 1, h, m).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: true });
};

// 643 -> "10m 43s"
export const formatDuration = (sec) => {
    if (sec === null || sec === undefined) return "-";
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return m ? `${m}m ${s}s` : `${s}s`;
};

export const formatDistance = (m) =>
    !m ? "-" : m < 1000 ? `${m} m` : `${(m / 1000).toFixed(1)} km`;

// Google encoded polyline -> [{ lat, lng }]
export const decodePolyline = (str) => {
    if (!str) return [];
    const pts = [];
    let i = 0, lat = 0, lng = 0;
    while (i < str.length) {
        let b, shift = 0, result = 0;
        do {
            b = str.charCodeAt(i++) - 63;
            result |= (b & 0x1f) << shift;
            shift += 5;
        } while (b >= 0x20);
        lat += result & 1 ? ~(result >> 1) : result >> 1;
        shift = 0;
        result = 0;
        do {
            b = str.charCodeAt(i++) - 63;
            result |= (b & 0x1f) << shift;
            shift += 5;
        } while (b >= 0x20);
        lng += result & 1 ? ~(result >> 1) : result >> 1;
        pts.push({ lat: lat / 1e5, lng: lng / 1e5 });
    }
    return pts;
};

const metersBetween = (a, b) => {
    const R = 6371000;
    const rad = (x) => (x * Math.PI) / 180;
    const dLat = rad(b.lat - a.lat);
    const dLng = rad(b.lng - a.lng);
    const h = Math.sin(dLat / 2) ** 2 + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLng / 2) ** 2;
    return 2 * R * Math.asin(Math.sqrt(h));
};

// speed_intervals (point indexes on the polyline) -> slow / jammed stretches with lat,lng + length
export const getTrafficSegments = (polyline, intervals = []) => {
    const pts = decodePolyline(polyline);
    return intervals
        .filter((v) => v.speed !== "NORMAL")
        .map((v) => {
            const seg = pts.slice(v.start_index, v.end_index + 1);
            let d = 0;
            for (let i = 1; i < seg.length; i++) d += metersBetween(seg[i - 1], seg[i]);
            return {
                speed: v.speed,
                distance_meters: Math.round(d),
                start: seg[0],
                end: seg[seg.length - 1],
            };
        });
};

export const WEEKDAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
 
// 0.62 -> "62%"
export const formatPercent = (f) => (f === null || f === undefined ? "-" : `${Math.round(f * 100)}%`);